var React = require('react');

function PhoneIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.458 0C.204 0 0 .19 0 .429v1.285h11V.43C11 .19 10.796 0 10.542 0H.458zM0 2.571v12h11v-12H0zM0 15.43v2.142c0 .238.204.429.458.429h10.084c.254 0 .458-.19.458-.429V15.43H0zm5.5.642c.38 0 .688.288.688.643 0 .355-.308.643-.688.643-.38 0-.688-.288-.688-.643 0-.355.308-.643.688-.643z"}));
}

PhoneIcon.defaultProps = {"viewBox":"0 0 11 18"};

module.exports = PhoneIcon;

PhoneIcon.default = PhoneIcon;
